import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import TopicsSection from "./components/TopicsSection";
import TreeHoleSection from "./components/TreeHoleSection";
import PlaySection from "./components/PlaySection";
import FaqSection from "./components/FaqSection";
import CommunitySection from "./components/CommunitySection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <HotSection />
        <TopicsSection />
        <TreeHoleSection />
        <PlaySection />
        <FaqSection />
        <CommunitySection />
      </main>
      <SiteFooter />
    </div>
  );
}